// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__15dZ8","active":"downloadDropdown_active__1GW2Z"};